import { dispatcher, DispatcherEvents } from "./dispatcher";
import { DriverActionTypes, ILoginRequiredState } from "../store/mobile/types";
import constants from "../constants";
import { OpenCabService } from "../services/openCab";

export class WebViewLayer {

    driverActionTypes = DriverActionTypes;

    pageNavigation: Function = constants.NOOP;
    driverActionNecessary: Function = constants.NOOP;
    newDutyStatusLog: Function = constants.NOOP;
    /**
     * The state cleanup the web top bar's cancelLoginLogout does before it leaves a workflow: clears the
     * Workflow driver action and the temporary asset selection. The native Log out on the login step calls
     * it, then routes to the login page itself.
     */
    clearLoginWorkflowState: () => void = constants.NOOP;
    loginRequired: (state: ILoginRequiredState) => void = constants.NOOP;
    /**
     * Notifies the native layer of the current ordered active-user list.
     * activeUsers[0] is the user currently viewing the app and is the session
     * that will be restored on the next cold start.
     * Called by AppView.activeUsersChanged via observeStore whenever the Redux
     * activeUsers slice changes.
     */
    syncActiveUsers: (activeUsers: string[]) => void = constants.NOOP;
    /**
     * Notifies the native layer that the Drive web app has established a session.
     * Called from loginSuccess after successful web-based login so the native
     * container can hydrate a session record for syncActiveUsers tracking.
     * Basic-auth logins provide `sessionId`; webview IAM logins provide `iamJwt`.
     */
    sessionEstablished: (arg: {
        server: string;
        database: string;
        userName: string;
        sessionId?: string;
        iamJwt?: string;
        oidcRefreshToken?: string;
        oidcIdToken?: string;
        oidcExpiresAt?: number;
        issuer?: string;
        clientId?: string;
        replacesSession?: boolean;
    }) => void = constants.NOOP;
    constructor() {
        dispatcher.on(DispatcherEvents.ViewPageloaded, (hash: string) => this.pageNavigation(hash));
        dispatcher.on(DispatcherEvents.WebViewLayerNewDutyStatusLog, (log) => this.newDutyStatusLog(log));
    }

    getApiUserNames() {
        return window.driveApp.userService.getActiveUserNames() || [];
    }

    getApi(userName: string) {
        let ctx = window.driveApp.manager.getCachedContext(userName);

        return ctx && ctx.addinService.getAddinApi() || null;
    }

    destroy() {
        dispatcher.off(DispatcherEvents.ViewPageloaded, this.pageNavigation);
        dispatcher.off(DispatcherEvents.WebViewLayerNewDutyStatusLog, this.newDutyStatusLog);
    }

    getOpenCabService(): OpenCabService | undefined {
        return window.driveApp.manager.openCabService;
    }
}

export let webViewLayer = new WebViewLayer();
